import React from "react";
import { useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { PropertyMap } from "@/components/PropertyMap";
import { PropertyCard } from "@/components/PropertyCard";
import { Seo } from "@/components/Seo";
import { Loader2, MapPin } from "lucide-react";

export default function MapView() {
  const [params] = useSearchParams();
  const filters = {
    q: params.get("q") || undefined,
    listing_type: params.get("listing_type") || undefined,
    property_type: params.get("property_type") || undefined,
    bedrooms: params.get("bedrooms") || undefined,
  };
  const { data = [], isLoading } = useQuery({
    queryKey: ["map-properties", params.toString()],
    queryFn: async () => (await api.get("/properties", { params: filters })).data,
  });

  return (
    <div className="grid grid-cols-1 lg:grid-cols-12 h-[calc(100vh-4rem)]">
      <Seo
        title="Property Map — Agricultural Land & Plots for Sale near Hyderabad | Dotlands Realty"
        description="See verified agricultural land, farm land and open plots for sale across Telangana on an interactive map with exact locations and prices near Hyderabad."
        path="/map"
      />
      <div className="lg:col-span-7 h-[45vh] lg:h-full relative border-r border-slate-200">
        {isLoading ? (
          <div className="flex items-center justify-center h-full"><Loader2 className="w-8 h-8 animate-spin text-emerald-600" /></div>
        ) : (
          <PropertyMap properties={data} />
        )}
      </div>
      <div className="lg:col-span-5 h-[55vh] lg:h-full overflow-y-auto bg-slate-50 p-4">
        <div className="flex items-center gap-2 mb-4 sticky top-0 bg-slate-50 py-2 z-10">
          <MapPin className="w-5 h-5 text-emerald-600" />
          <h1 className="font-heading font-bold text-lg text-slate-900">{data.length} properties on map</h1>
        </div>
        <div className="grid grid-cols-1 gap-4">
          {data.map((p, i) => <PropertyCard key={p.id} p={p} index={i} />)}
        </div>
      </div>
    </div>
  );
}
